<b3-drawer
  [open]="open"
  size="md"
  overlay
  (b3-close)="close()"
  (b3-back)="close()">
  <b3-drawer-header
    heading="Detalhes da Operação"
    show-back
    back-aria-label="Fechar detalhes da operação">
  </b3-drawer-header>

  <b3-drawer-body>
    <div class="operation-details-drawer" *ngIf="details">
      <div class="operation-details-drawer__badges">
        <b3-tag
          size="sm"
          variant="filled"
          icon="currency_exchange"
          tone="info"
          [label]="details.operationLabel">
        </b3-tag>
        <b3-tag
          size="sm"
          variant="filled"
          tone="info"
          icon="check_circle"
          label="ACX">
        </b3-tag>
      </div>

      <div class="operation-details-drawer__field operation-details-drawer__field--full">
        <span class="operation-details-drawer__label">{{ details.outsideB3Label }}</span>
        <span class="operation-details-drawer__value">{{ details.outsideB3Answer }}</span>
      </div>

      <div class="operation-details-drawer__field operation-details-drawer__field--full">
        <span class="operation-details-drawer__label">{{ details.accountLabel }}</span>
        <span class="operation-details-drawer__value">{{ details.accountValue }}</span>
      </div>

      <div class="operation-details-drawer__field operation-details-drawer__field--full">
        <a
          class="operation-details-drawer__link"
          [href]="acxPlatformUrl"
          target="_blank"
          rel="noopener noreferrer"
          (click)="onAcxLinkClick($event)">
          {{ details.acxInfoLinkLabel }}
        </a>
      </div>

      <div class="operation-details-drawer__actions">
        <b3-button
          class="operation-details-drawer__confirm-btn"
          type="button"
          variant="filled"
          tone="default"
          (b3-click)="close()">
          <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
          Entendi
        </b3-button>
      </div>
    </div>
  </b3-drawer-body>
</b3-drawer>
